const footer = {
   intro:'Ut leo velit, tempor non lorem sit amet, vulputate feugiat nisl. Nulla arcu velit, rhoncus quis cursus eu, cursus vel est. Vestibulum convallis odio risus, vel congue felis bibendum lacinia. Vestibulum lobortis molestie',
   
}

export default footer;